import { followingSidebar } from '../../utils/sidebar.utils.js';

const equalizersRegistry = new WeakMap();
const rowTopTolerance = 4;
const equalizedSelectors = [
  '.job-card__meta',
  '.job-card__title',
  '.job-card__details',
];

const getSearchJobCards = (grid) => {
  return Array.from(grid.querySelectorAll('.job-card'));
};

const getSearchJobCardRows = (grid) => {
  const cards = getSearchJobCards(grid);
  const rows = [];

  cards.forEach((card) => {
    const top = card.getBoundingClientRect().top;
    const existingRow = rows.find((row) => {
      return Math.abs(row.top - top) <= rowTopTolerance;
    });

    if (existingRow) {
      existingRow.cards.push(card);
      existingRow.top = Math.min(existingRow.top, top);
      return;
    }

    rows.push({
      top,
      cards: [card],
    });
  });

  return rows
    .sort((a, b) => a.top - b.top)
    .map((row) => row.cards);
};

const getSearchJobCardEqualizerGroups = (grid) => {
  const rows = getSearchJobCardRows(grid);
  const groups = [];

  rows.forEach((row) => {
    equalizedSelectors.forEach((selector) => {
      const elements = row
        .map((card) => card.querySelector(selector))
        .filter(Boolean);

      if (elements.length) {
        groups.push(elements);
      }
    });
  });

  return groups;
};

const setupSearchJobCardsEqualizer = (grid) => {
  const equalizer = equalizersRegistry.get(grid);

  if (equalizer) {
    equalizer.refresh();
    return;
  }

  if (typeof window.lineTitlesFunc !== 'function') {
    return;
  }

  equalizersRegistry.set(
    grid,
    window.lineTitlesFunc([], {
      getGroups: () => getSearchJobCardEqualizerGroups(grid),
    })
  );
};

const refreshSearchJobCardsEqualizer = (scope = document) => {
  const root = scope instanceof Element ? scope : document;
  const grids = root.matches?.('.search-sec__result-grid')
    ? [root]
    : Array.from(root.querySelectorAll('.search-sec__result-grid'));

  grids.forEach((grid) => {
    if (!getSearchJobCards(grid).length) {
      return;
    }

    setupSearchJobCardsEqualizer(grid);
  });
};

window.refreshSearchJobCardsEqualizer = refreshSearchJobCardsEqualizer;
window.initSearchJobCardsEqualizer = refreshSearchJobCardsEqualizer;

document.querySelectorAll('.search-sec').forEach((searchSection) => {
  const sidebar = searchSection.querySelector('#sidebar');
  const contentSticky = searchSection.querySelector('#content-sticky');
  const filtersBtn = searchSection.querySelector('#filters-btn');
  const contentResult = searchSection.querySelector('#content-result');

  const isColumnTypeSec = searchSection.classList.contains('column-type');
  const desktopStickyGap = 64;

  if (sidebar && contentSticky && window.innerWidth >= 852 && !isColumnTypeSec) {
    followingSidebar({
      sidebar,
      contentSticky,
      gap: desktopStickyGap,
      bottomGap: desktopStickyGap,
    });
  }

  if (filtersBtn && sidebar && contentSticky && contentResult) {
    filtersBtn.addEventListener('click', () => {
      filtersBtn.classList.toggle('is-open-filters');
      sidebar.classList.toggle('is-open-filters');
      contentSticky.classList.toggle('is-open-filters');
      contentResult.classList.toggle('is-open-filters');
    });

    contentResult.addEventListener('click', () => {
      if (contentResult.classList.contains('is-open-filters')) {
        filtersBtn.classList.remove('is-open-filters');
        sidebar.classList.remove('is-open-filters');
        contentSticky.classList.remove('is-open-filters');
        contentResult.classList.remove('is-open-filters');
      }
    });
  }

  const sidebarAccordionButtonsArr = searchSection.querySelectorAll('.search-sec__sidebar-item-btn');

  if (sidebarAccordionButtonsArr.length) {
    sidebarAccordionButtonsArr.forEach((btn) => {
      const item = btn.closest('.search-sec__sidebar-item-toggle');
      const toggleEl = item;

      if (!toggleEl) return;

      if (!toggleEl.classList.contains('is-active')) {
        item.classList.add('is-closed');
      }

      const toggleItem = () => {
        const isOpen = toggleEl.classList.contains('is-active');

        toggleEl.classList.toggle('is-active', !isOpen);
        item.classList.toggle('is-closed', isOpen);
      };

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleItem();
      });

      item.addEventListener('click', () => {
        toggleItem();
      });
    });
  }
});

refreshSearchJobCardsEqualizer();

/*if (document.getElementsByClassName('job-search-section__form')[0]) {
  const checkboxesTypes = document.querySelectorAll(
    'input[type="checkbox"][name="type[]"], input[type="checkbox"][name="type_second[]"]'
  );

  function syncCheckboxes(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesTypes.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesTypes.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxes);
  });

  const checkboxesSectors = document.querySelectorAll(
    'input[type="checkbox"][name="sector[]"], input[type="checkbox"][name="sector_second[]"]'
  );

  function syncCheckboxesSectors(event) {
    const targetCheckbox = event.target;
    const isChecked = targetCheckbox.checked;
    const targetValue = targetCheckbox.value;

    checkboxesSectors.forEach((checkbox) => {
      if (checkbox.value === targetValue) {
        checkbox.checked = isChecked;
      }
    });
  }

  checkboxesSectors.forEach((checkbox) => {
    checkbox.addEventListener('change', syncCheckboxesSectors);
  });
}*/
